// src/redux/categories/categoriesSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categories: [],
  isLoading: false,
  error: null,
};

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setCategories(state, action) {
      state.categories = action.payload;
    },
    setCategoriesLoading(state, action) {
      state.isLoading = action.payload;
    },
    setCategoriesError(state, action) {
      state.error = action.payload;
    },
  },
});

export const { setCategories, setCategoriesLoading, setCategoriesError } =
  categoriesSlice.actions;

export default categoriesSlice.reducer;
